/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProjectType = {
    Recurring: 'RECURRING',
    Short: 'SHORT'
} as const;
export type ProjectType = typeof ProjectType[keyof typeof ProjectType];


export function instanceOfProjectType(value: any): boolean {
    for (const key in ProjectType) {
        if (Object.prototype.hasOwnProperty.call(ProjectType, key)) {
            // @ts-ignore
            if (ProjectType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProjectTypeFromJSON(json: any): ProjectType {
    return ProjectTypeFromJSONTyped(json, false);
}

export function ProjectTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectType {
    return json as ProjectType;
}

export function ProjectTypeToJSON(value?: ProjectType | null): any {
    return value as any;
}

